import store from '@/store';
import { SetDiffStatePayload } from '@/store/mutations/diffMutations';

export const commitSetDiffState = (payload: SetDiffStatePayload) => {
  store.commit('setDiffState', payload);
};

export const commitClearDiffState = () => {
  store.commit('clearDiffState');
};
